module.exports = __webpack_public_path__ + "img/doorpostdescribeLogo.33db8e01.png";